import axios from '@/plugins/axios/https';

export function ApiEdmList({ search, limit, offset }) {
  const form = {
    limit,
    offset
  };

  if (search) {
    form.search = search;
  }

  return axios.get('/edm/', form);
}

export function ApiEdmCreate({ name, type }) {
  const form = {
    name
  };

  if (type) {
    form.type = type;
  }

  return axios.post('/edm/create/', form);
}

export function ApiEdmDelete({ uuid }) {
  return axios.post(`/edm/${uuid}/delete/`);
}

export function ApiEdmProfile({ uuid }) {
  return axios.get(`/edm/${uuid}/profile/`);
}

export function ApiEdmSave({ uuid, data }) {
  const form = {
    ...data
  };

  return axios.post(`/edm/${uuid}/save/`, form, {
    loading: false
  });
}

export function ApiEdmBeefreeToken() {
  return axios.get('/edm/get-beefree-token/');
}

export function ApiEdmApplyTemplate({ uuid, templateUuid }) {
  const form = {
    templateUuid
  };

  return axios.post(`/edm/${uuid}/apply-template/`, form);
}

export function ApiEdmSendTestMail({ subject, htmlfile }) {
  const body = {
    subject,
    htmlfile
  };

  return axios.post(`/edm/send-preview/`, body);
}
